<template>
  <div class="card card-custom">
    <div class="card-header">
      <div class="card-title">
        <ActionButton
          class="mr-3"
          v-b-toggle.vorgaengeDetails-collapse
          title="Ausklappen"
          :iconClass="isCollapseOpen ? 'ki ki-arrow-up' : 'ki ki-arrow-down'"
          @click="toggleCollapse"
        />
        <h3 class="card-label">Vorgänge</h3>
        <b-form-checkbox
          class="mr-1"
          v-model="isBuchungFilterEnabled"
          switch
          style="display: flex; font-size: 14px"
          v-if="activeTabFromRouter === 'vorgaenge'"
        >
          Nur feste Buchungen anzeigen
        </b-form-checkbox>
      </div>
      <div class="card-toolbar">
        <ul class="nav nav-tabs nav-bold nav-tabs-line">
          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, vorgangdetailstab: 'vorgaenge' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'vorgaenge' }" :href="href">
                <span class="nav-icon"><i class="far fa-file-alt"></i></span>
                <span class="nav-text">Vorgangsübersicht</span>
              </a>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, vorgangdetailstab: 'teilnehmer' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'teilnehmer' }" :href="href">
                <span class="nav-icon"><i class="fas fa-user-check"></i></span>
                <span class="nav-text">Teilnehmerdaten</span>
              </a>
            </router-link>
          </li>
          <li v-if="!isReiseOhneFlugComputed" class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, vorgangdetailstab: 'fluege' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'fluege' }" :href="href">
                <span class="nav-icon"><i class="fas fa-plane"></i></span>
                <span class="nav-text">Flüge</span>
              </a>
            </router-link>
          </li>

          <li v-if="!isReiseOhneFlugComputed" class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, vorgangdetailstab: 'transfer' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'transfer' }" :href="href">
                <span class="nav-icon"><i class="fas fa-bus"></i></span>
                <span class="nav-text">Transfer</span>
              </a>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, vorgangdetailstab: 'optionalsAndExtensions' },
              }"
              v-slot="{ href }"
            >
              <a
                class="nav-link"
                :class="{ active: activeTabFromRouter === 'optionalsAndExtensions' }"
                :href="href"
              >
                <span class="nav-icon"><i class="fas fa-suitcase"></i></span>
                <span class="nav-text">Optionals & Verlängerungen</span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <b-collapse visible id="vorgaengeDetails-collapse">
      <div class="card-body" style="padding: 16px 24px">
        <div v-if="!isLoading" class="tab-content">
          <div
            v-show="activeTabFromRouter === 'vorgaenge'"
            :class="{ show: activeTabFromRouter === 'vorgaenge' }"
            class="tab-pane active"
          >
            <VorgangTable
              v-if="vorgaenge"
              :items="filteredVorgaengeOverview"
              :isLoading="isLoading"
              :hiddenItemsCount="
                isBuchungFilterEnabled ? this.vorgaenge.length - this.filteredVorgaenge.length : null
              "
              :displayFieldsByKey="[
                'id',
                'reisezeitraum',
                'teilnehmende',
                'zimmer',
                'npx',
                'agentur',
                'brutto',
                'isReleased',
                'stateSlot',
              ]"
              :dokumenteCheckRequired="dokumenteCheckRequired"
              :passdatenCheckRequired="passdatenCheckRequired"
              :reiseterminId="reiseterminObj.id"
              @update-single-item="updateItemInRow"
            >
              <template #stateSlot="row">
                <VorgangStateWidget :state="row.item.blankState" />
              </template>
            </VorgangTable>
          </div>
          <div
            v-show="activeTabFromRouter === 'teilnehmer'"
            :class="{ show: activeTabFromRouter === 'teilnehmer' }"
            class="tab-pane active"
          >
            <ReiseterminCardVorgaengeTeilnehmer
              v-if="vorgaenge"
              :reisetermin="reiseterminObj"
              :konfiguration="gueltigeKonfiguration"
              :vorgaenge="filteredVorgaenge"
            ></ReiseterminCardVorgaengeTeilnehmer>
          </div>
          <div
            v-if="!isReiseOhneFlugComputed"
            v-show="activeTabFromRouter === 'fluege'"
            :class="{ show: activeTabFromRouter === 'fluege' }"
            class="tab-pane active"
          >
            <ReiseterminCardVorgaengeFluege
              v-if="vorgaenge"
              :isLoading="isLoading"
              :reiseterminObj="reiseterminObj"
              :blankVorgaenge="filteredVorgaenge"
            ></ReiseterminCardVorgaengeFluege>
          </div>

          <div
            v-if="!isReiseOhneFlugComputed"
            v-show="activeTabFromRouter === 'transfer'"
            :class="{ show: activeTabFromRouter === 'transfer' }"
            class="tab-pane active"
          >
            <ReisetermineCardVorgaengeTransfer
              :reiseterminId="reiseterminObj.id"
              :reiseterminkuerzel="reiseterminObj.reiseterminkuerzel"
              :metadata="reiseterminObj.metadata"
              :pax="reiseterminObj.pax"
              :vorgaenge="filteredVorgaenge"
            ></ReisetermineCardVorgaengeTransfer>
          </div>

          <div
            v-show="activeTabFromRouter === 'optionalsAndExtensions'"
            :class="{ show: activeTabFromRouter === 'optionalsAndExtensions' }"
            class="tab-pane active"
          >
            <ReisetermineCardVorgaengeOptionalsAndExtensions
              :vorgaenge="filteredVorgaenge"
            ></ReisetermineCardVorgaengeOptionalsAndExtensions>
          </div>
        </div>
        <div v-if="isLoading" class="tab-content">
          <b-skeleton-table :rows="5" :columns="6"></b-skeleton-table>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import {
  GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER,
  GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID,
} from '@/core/vorgaenge/stores/vorgaenge.module';

import ReiseterminCardVorgaengeTeilnehmer from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-teilnehmer.vue';
import ReiseterminCardVorgaengeFluege from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-fluege.vue';
import VorgangTable from '@/components/vorgaenge/vorgang-table.vue';
import VorgangStateWidget from '@/components/vorgaenge/vorgang-state-widget.vue';
import ActionButton from '@/components/common/action-button.vue';
import ReisetermineCardVorgaengeTransfer from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-transfer.vue';

import { formatDateWithoutHours, isReiseOhneFlug } from '@/core/common/helpers/utils.js';

import { mapState } from 'vuex';
import { utils, writeFileXLSX } from 'xlsx';
import ReisetermineCardVorgaengeOptionalsAndExtensions from './reisetermine-card-vorgaenge-optionalsAndExtensions.vue';

export default {
  name: 'ReiseterminViewCardVorgaengeReleaseProcessComponent',
  components: {
    ReiseterminCardVorgaengeTeilnehmer,
    ReiseterminCardVorgaengeFluege,
    VorgangTable,
    VorgangStateWidget,
    ActionButton,
    ReisetermineCardVorgaengeOptionalsAndExtensions,
    ReisetermineCardVorgaengeTransfer,
  },
  props: {
    reiseterminObj: { type: Object },
    gueltigeKonfiguration: { type: Object },
  },
  data() {
    return { isBuchungFilterEnabled: false, isCollapseOpen: true };
  },
  async mounted() {
    if (Array.isArray(this.vorgaenge) && this.vorgaenge.length <= 0 && !this.isLoading) {
      this.getTeilnehmerAndFluege(this.reiseterminObj.id);
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.vorgaenge.isLoading,
      isInitialLoading: state => state.vorgaenge.isInitialLoading,
      vorgaenge: state => state.vorgaenge.vorgaenge,
      thwerteAtBuchungsdatumByVorgangId: state => state.vorgaenge.thwerteAtBuchungsdatumByVorgangId,
    }),
    isReiseOhneFlugComputed() {
      return isReiseOhneFlug(this.reiseterminObj?.metadata);
    },
    teilnehmerListenDeutschEnglisch() {
      const sortedVorgaenge = [...this.vorgaenge].sort((a, b) => {
        return new Date(a.reisedatum) - new Date(b.reisedatum);
      });
      const firstVorgang = sortedVorgaenge[0];
      const lastVorgang = sortedVorgaenge[sortedVorgaenge.length - 1];
      return [
        `https://skr3-metabase.azurewebsites.net/question/276-participants-teilnehmerliste-englisch?from=${firstVorgang?.reisedatum}&until=${lastVorgang?.reisedatum}&reisekuerzel=${this.reiseterminObj.reise.reisekuerzel}`,
        `https://skr3-metabase.azurewebsites.net/question/258-teilnehmerliste?from=${firstVorgang?.reisedatum}&until=${lastVorgang?.reisedatum}&reisekuerzel=${this.reiseterminObj.reise.reisekuerzel}`,
      ];
    },
    filteredVorgaengeOverview() {
      return this.isBuchungFilterEnabled
        ? this.vorgaenge.filter(vorgang => vorgang.blankState === 'Buchung' || vorgang.isReleased)
        : this.vorgaenge;
    },
    filteredVorgaenge() {
      return this.vorgaenge.filter(
        vorgang => vorgang.blankState === 'Buchung' || vorgang.blankState === 'Option' || vorgang.isReleased
      );
    },
    activeTabFromRouter() {
      return this.$route.query.vorgangdetailstab || 'vorgaenge';
    },
    dokumenteCheckRequired() {
      return this.gueltigeKonfiguration?.dokumente;
    },
    passdatenCheckRequired() {
      return this.gueltigeKonfiguration?.passdaten;
    },
  },
  watch: {
    async reiseterminObj() {
      this.getTeilnehmerAndFluege(this.reiseterminObj.id);
    },
    isInitialLoading(isLoading) {
      if (!isLoading && this.$route.query.scrollToFlugdaten) {
        const element = document.getElementById('reiseterminCardVorgaengeDetails');
        const offset = element.getBoundingClientRect();
        if (element) {
          setTimeout(() => {
            window.scrollTo({
              // offset y minus headers
              top: offset.y - (190 + 65 + 52),
              left: 0,
              behavior: 'smooth',
            });
          }, 100);
        }
      }
    },
  },
  methods: {
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen;
    },
    async updateItemInRow() {
      this.$emit('update-single-item');
    },
    async getTeilnehmerAndFluege(reiseterminId) {
      const id = reiseterminId;
      return this.$store
        .dispatch(GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER, {
          reiseterminId: id,
        })
        .then(response => {
          this.$store.dispatch(GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID, {
            reiseterminId: id,
            vorgaenge: response.filter(v => v.buchungsdatum != null),
          });
        });
    },
  },
};
</script>
